import React from 'react';
import classNames from 'classnames';
import { IconButton } from '@agissc/ktag-map';

interface FavoriteButtonProps {
  additionalClassNames?: string;
  title?: string;
  isFavorite?: boolean;
  onClick: () => void;
}

const FavoriteButton = ({
  additionalClassNames,
  onClick,
  title,
  isFavorite,
}: FavoriteButtonProps) => {
  return (
    <IconButton
      onClick={onClick}
      additionalClassNames={classNames(additionalClassNames, {
        'favorite-button--active-fill': isFavorite,
      })}
      isActive={isFavorite}
      title={title}
      icon="star"
    />
  );
};

export default FavoriteButton;
